import { render, staticRenderFns } from "./NewLanding__4.vue?vue&type=template&id=a7ace90a&scoped=true&"
import script from "./NewLanding__4.vue?vue&type=script&lang=js&"
export * from "./NewLanding__4.vue?vue&type=script&lang=js&"
import style0 from "./NewLanding__4.vue?vue&type=style&index=0&id=a7ace90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ace90a",
  null
  
)

export default component.exports